import './styles.css'
const SearchButton = () => {
    return (
        <button className='btn btn-primary btn-style'>
            <h6>BUSCAR</h6>
        </button>
    );
}

export default SearchButton;